import { ModalForm } from './ModalForm';

export type { TypeModalFormProps } from './types';
export default ModalForm;
